import { render, staticRenderFns } from "./drCfg.vue?vue&type=template&id=46f3cb25&scoped=true&"
import script from "./drCfg.vue?vue&type=script&lang=js&"
export * from "./drCfg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f3cb25",
  null
  
)

export default component.exports